/**
 * Unescape reserved characters and seismic
 * Currently, only @ is reserved, we can expand this later if needed
 *
 * @private
 * @param state
 * @param container
 * @returns Object - State
 */
export default function unescapeReservedCharacters(state) {
	for (const k in state.properties) {
		const value = state.properties[k];
		if (typeof value === 'string' && (value.startsWith('\\@') || value.startsWith('\\\\@'))) {
			state.properties[k] = value.slice(1);
		}
	}
	return state;
}
